import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from "../../../environments/environment";
import { Observable, Subject, of, ReplaySubject } from 'rxjs';
import { FinancialReconciliationReportResult } from '../models/request/financial-reconciliation-report-result';

@Injectable({
    providedIn: 'root'
})
export class SignalRNotificationsService {
    public context: any;
    
    private initialized: boolean = false;
    private reconciliationInitialized = false;
    
    private connectionEstablished: boolean = false;
    private connectionEstablishedEvent = new ReplaySubject<void>(1);

    private connection: signalR.HubConnection;
    private messageSubjects: { [key: string]: Subject<any> } = {};
    private joinedGroups = new Set<string>();

    private onDestroy$: Subject<void> = new Subject<void>();

    constructor() {
    }

    public initReconciliation(file: File){
        if (!this.reconciliationInitialized){
            this.connection.on('FinancialReconciliationCompleted', (response) => {
                this.financialReconciliationCompleted(response);
            });

            this.reconciliationInitialized = true;
        }

        this.SignalRConnected(file);
    }

    private financialReconciliationCompleted(response: FinancialReconciliationReportResult): void {
        if (this.onFinancialReconciliationCompleted && typeof this.onFinancialReconciliationCompleted === 'function') {
            this.onFinancialReconciliationCompleted(this.context, response);
        } else {
            ///todo: сделать обработку результата, если пользователь ушел со страницы заявок
        }
    }

    private SignalRConnected(file: File): void {
        if (this.onSignalRConnected && typeof this.onSignalRConnected === 'function') {
            this.onSignalRConnected(this.context, file);
        } else {
            ///todo: сделать обработку результата, если пользователь ушел со страницы заявок
        }
    }

    public onFinancialReconciliationCompleted = (context: any, response: FinancialReconciliationReportResult) => {};

    public onSignalRConnected = (context: any, file: File) => {};

    closeConnection(){
        if (this.connection) {
            this.connection.stop().then(() => {
                console.log('SignalR connection stopped');
                this.connection = undefined;
                this.initialized = false;
                this.connectionEstablished = false;
                this.joinedGroups.clear();
                this.connectionEstablishedEvent = new ReplaySubject<void>(1);
            }).catch(err => {
                console.error('Error stopping SignalR connection:', err);
            });
        }
    }

    startConnection(): Observable<any> {
        if (this.initialized && this.connectionEstablished){
            return of(true);
        }
        if (this.initialized){
            return this.connectionEstablishedEvent.asObservable();
        }

        window.addEventListener('beforeunload', () => {
            // Close the SignalR connection
            if (this.connection) {
                this.connection.stop().then(() => {
                    console.log('SignalR connection stopped');
                }).catch(err => {
                    console.error('Error stopping SignalR connection:', err);
                });
            }
        });

        this.initialized = true;

        const options: signalR.IHttpConnectionOptions = {
            accessTokenFactory: () => {
                let authUserJson = localStorage.getItem("authUser");
                let authUser = JSON.parse(authUserJson);
                return authUser.bearerToken;
            }
        };

        this.connection = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Information)
            .withUrl(`${environment.baseUrl}/hubs/notifications`, options)
            .withAutomaticReconnect()
            .build();
        
        this.connection
            .start()
            .then(() => {
                console.log('Connection started');
                this.connectionEstablished = true;
                this.connectionEstablishedEvent.next();
            })
            .catch((err) => console.log('Error while starting connection: ' + err));

        this.connection.onreconnected(() => {
            console.log('SignalR reconnected, restoring groups');
            this.connectionEstablished = true;
            this.rejoinGroups();
        });
          
        this.connection.onclose((error) => {
            console.log('SignalR disconnected.');
            console.log(error);
            this.connectionEstablished = false;
        });

        return this.connectionEstablishedEvent.asObservable();    
    }

    public addToGroup(groupName: string): void {
        if (!groupName) {
            return;
        }

        this.joinedGroups.add(groupName);
        this.invokeAddToGroup(groupName);
    }

    public getOrCreateMessageListener(messageAddress: string): Observable<any> {
        if (this.messageSubjects[messageAddress]) {
            return this.messageSubjects[messageAddress].asObservable();
        }

        let messageSubject = new Subject<any>();
        this.messageSubjects[messageAddress] = messageSubject;        
        
        this.connection.on(messageAddress, (message) => {
            messageSubject.next(message);
        });

        return this.messageSubjects[messageAddress].asObservable();
    }

    private rejoinGroups(): void {
        this.joinedGroups.forEach(groupName => this.invokeAddToGroup(groupName));
    }

    private invokeAddToGroup(groupName: string): void {
        if (!this.connection || this.connection.state !== signalR.HubConnectionState.Connected) {
            return;
        }

        this.connection.invoke('AddToGroup', groupName)
          .catch(err => console.error(err));
    }
}
